import React from 'react';

const MANAGE_URL =
  process.env.REACT_APP_ACCOUNT_PORTAL_URL || 'https://manage.codiii.com';

export default function BillingAdminRedirect() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        fontFamily: 'Montserrat, system-ui, sans-serif',
        background: '#f8fafc',
      }}
    >
      <div
        style={{
          maxWidth: 480,
          background: '#fff',
          borderRadius: 16,
          padding: 32,
          boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
          textAlign: 'center',
        }}
      >
        <h1 style={{ margin: '0 0 12px', fontSize: 22 }}>Account administration only</h1>
        <p style={{ color: '#64748b', lineHeight: 1.5 }}>
          Your account is set up to manage licenses and billing, not to use the CODiii
          application directly.
        </p>
        <a
          href={MANAGE_URL}
          style={{
            display: 'inline-block',
            marginTop: 20,
            padding: '12px 20px',
            background: '#f97316',
            color: '#fff',
            borderRadius: 8,
            textDecoration: 'none',
            fontWeight: 700,
          }}
        >
          Go to manage.codiii.com
        </a>
      </div>
    </div>
  );
}
